module.exports = __webpack_public_path__ + "img/TITLE-01.2189756b.png";